import React from 'react';
import styled, { css } from 'styled-components';

import { useSollersHomeData } from '@/modules/SollersHome/hooks';
import { ContentContainer } from '@/modules/SollersHome/common.styles';
import { AboutCardSecondary } from '@/components/LandingWidgets';
import { media } from '@/utils/mixin';

function TradeIn() {
  const { tradeInTitle, tradeInDescription, tradeInBenefits } =
    useSollersHomeData();

  if (!tradeInBenefits || tradeInBenefits.length === 0) {
    return null;
  }

  return (
    <Component id="trade-in">
      <ContentContainer>
        <AboutCardSecondary
          id={5}
          title={tradeInTitle ?? ''}
          description={tradeInDescription ?? ''}
          benefits={tradeInBenefits.map(({ image, title, description }) => ({
            image,
            title: title ?? '',
            description: description ?? '',
          }))}
        />
      </ContentContainer>
    </Component>
  );
}

export default TradeIn;

const Component = styled.section`
  padding: 30px 0;

  ${media.tablet(css`
    padding: 20px 0;

    ${ContentContainer} {
      padding: 0 20px;
    }
  `)}
`;
